<ng-container>
    <div class="flex flex-wrap gap-1 p-1">
        <ng-container *ngFor="let item of items">
            <fui-badge
                [title]="item.name"
                [image]="getIcon(item)"
                [color]="getColor(item)"
                [useBorder]="true"
                [useBackground]="true"
            ></fui-badge>
        </ng-container>
    </div>
</ng-container>
